export default __webpack_public_path__ + "static/media/knife.2cb9f975.svg";